import FlashIcon from "@/components/atoms/dynamic-icons/flash";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Percent, Wallet } from "lucide-react";
import Link from "next/link";
import React from "react";
import { getMarketplaceUrl } from "@/lib/marketplace-utils";

export default function PaymentOptionsCards() {
  const paymentOptions = [
    {
      id: "hybrid",
      title1: "Pay an Upfront",
      title2: "Spread the Rest.",
      description: "Make a down payment and spread the remaining balance over time.",
      cta: "Shop with Hybrid Payments",
      features: ["Perfect for higher-value items."],
      icon: Percent,
    },
    {
      id: "bnpl",
      title1: "Buy Now",
      title2: "Pay Later.",
      description: "Get What you need today Pay in installment Overtime.",
      cta: "Shop with BNPL",
      features: ["Instant Eligibility Check", "Clear repayment dates", "Notifications and reminder"],
      icon: Wallet,
    },
    {
      id: "pay-in-full",
      title1: "Pay Once",
      title2: "Own It Immediately.",
      description: "Prefer to pay in full?",
      cta: "Shop Now",
      features: ["Enjoy quick checkout and fast delivery."],
      icon: FlashIcon,
    },
  ];
  return (
    <div id='how-will-i-pay' className='mx-auto w-full px-4 pt-12 md:max-w-5xl md:px-0 md:pt-30'>
      <h3 className='text-text-title mb-7 text-center text-3xl'>How will I pay?</h3>
      <div className='grid grid-cols-1 gap-5 md:grid-cols-3 md:items-start md:justify-between md:gap-4 xl:gap-7'>
        {paymentOptions.map((option) => (
          <Card key={option.id}>
            <CardContent className='px-4 xl:px-6'>
              <div className='border-border-title mx-auto flex size-12 items-center justify-center rounded-full border-3 md:size-17'>
                <option.icon className='text-icon-title size-8 md:size-10' />
              </div>
              <p className='text-icon-disabled mt-6 text-center text-xs leading-4 font-semibold md:text-sm'>
                {option.description}
              </p>
              <div className='text-text-title mt-4 text-center text-lg leading-5 font-medium sm:text-xl sm:leading-7 xl:text-3xl'>
                {option.title1}
                <span className='text-link-primary'>.</span>
                <br />
                {option.title2}
              </div>
              <Link href={getMarketplaceUrl("/shop")}>
                <Button className='mt-5 w-full py-6'>{option.cta}</Button>
              </Link>
              <div className='bg-bg-tetiary mt-5 rounded-2xl px-3 py-2'>
                {option.features.map((feature, index) => (
                  <p key={index} className='my-3 flex items-center gap-2'>
                    <span className='border-border-title flex size-5 shrink-0 items-center justify-center rounded-full border'>
                      <span className='bg-icon-title size-2 rounded-full'></span>
                    </span>
                    <span className='text-text-title text-sm leading-4 font-medium'>{feature}</span>
                  </p>
                ))}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
